import { render, staticRenderFns } from "./SharedPanel.vue?vue&type=template&id=3b7360f9&scoped=true"
import script from "./SharedPanel.vue?vue&type=script&lang=ts"
export * from "./SharedPanel.vue?vue&type=script&lang=ts"
import style0 from "@/css/shared-modal.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./SharedPanel.vue?vue&type=style&index=1&id=3b7360f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7360f9",
  null
  
)

export default component.exports